export default __webpack_public_path__ + "static/media/hedges-unselected.eb69b461.png";